<style lang="less" scoped>
  #header {
    width: 100%;
    .header-desktop {
      width: 100%;
      background-color: #ffffff;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
      display: flex;
      height: 104px;

      .logo-cover {
        flex: 1;
        display: flex;
      }
        .logo {
          align-items: center;
          display: flex;
        }

      .member-cover {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-content: center;

        .member-info {
          display: flex;
          align-content: center;
          padding-right: 16px;

          .member-grade, .member-name {
            display: flex;
            align-self: center;
          }

          .member-grade {
            margin-right: 5px;
          }
        }
      }
    }

    .container {
      width: 100%;
      max-width: 960px;
      margin: auto;
      padding: 0 32px;
      display: flex;
    }
  }

  .header-mobile {
    display: none;
    background-color: #ffffff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);

    .mobile-title {
      font-size: 17px;
      flex: 1;
      text-align: center;
    }
  }

  .header-mobile {
    display: none;
    padding: 18px 20px;
    width: 100%;

    .header-history-cover {
      display: flex;
      flex: 1;
      align-items: center;

      .header-mobile-close {
        width: 20px;
      }
    }
    .mobile-title {
      flex: 1;
      position: absolute;
      left: 0;
      width: 100%;
      z-index: -1;
    }
    .header-options-cover {
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: flex-end;
    }
  }

  .mobile-myinfo-dialog-cover {
    .myinfo-row {
      margin-bottom: 4px;
      > strong {
        margin-right: 5px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    .logout-btn-cover {
      padding: 0 16px 16px;
    }
  }
  .logo-cover {
    img {
      width: 247px;
    }
  }
  .user-icon {
    width: 24px;
    height: 24px;
  }

  @media screen and (max-width: 560px) {
    #header {
      .header-desktop {
        display: none;
      }

      .header-mobile {
        display: flex;
        position: fixed;
        top: 0;
        z-index: 1000;
      }
    }
  }
</style>

<template lang="pug">
  #header
    el-dialog.custom-dialog(title="나의 회원정보" :visible.sync="isOpenMyinfoDialog")
      .mobile-myinfo-dialog-cover
        .myinfo-cover.dialog-content-cover
          .myinfo-row
            strong 이름
            span {{name}}
          .myinfo-row
            strong 유형
            span {{type === 'doctor' ? '사업자' : '학생'}}
        .logout-btn-cover
          el-button.w10(type="success" @click="logout") 로그아웃
    .header-desktop
      .container
        .logo-cover
          router-link(to="/mylist")
            img.logo(src="@/assets/happytree-desktop@2x.png")
        .member-cover
          .member-info
            strong.member-grade 사용자
            span.member-name {{name}}
          el-button.member-logout-btn(@click="logout") 로그아웃
    .header-mobile
      .header-history-cover
        img.header-mobile-close(src="@/assets/navigation-left@2x.png" @click="$router.go(-1)")
      strong.mobile-title {{title}}
      .header-options-cover
          img.user-icon(
            src="@/assets/user@2x.png",
            @click="isOpenMyinfoDialog = true",
            v-if="me")
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: ['title'],
  data() {
    return {
      isOpenMyinfoDialog: false,
      name: null,
      type: null,
    };
  },
  computed: {
    ...mapState({
      me: state => state.app.me,
    }),
  },
  methods: {
    logout() {
      this.$localStorage.set('token', null);
      this.$store.commit('setMe', null);
      this.$router.replace('/login');
    },
  },
  mounted() {
    if (this.me) {
      this.name = this.me.name;
      this.type = this.me.type;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/header.vue